import { z } from "zod";

export const facilityNoteSchema = z.object({
  content: z.string().min(1, { message: "Please enter your note." }),
});
